<template>
  <Card class="contract-decline" tag="form" @submit.prevent="submit">
    <template #default>
      <InputComponent v-model="reason" required type="textarea" :label="$t('reason')" :disabled="!hasAccess">
        <template #below v-if="hasAccess">
          <Alert class="mt-1">{{ $t('reasonWillBeSentToApplicants') }}</Alert>
        </template>
      </InputComponent>
    </template>
    <template #footer>
      <template v-if="hasAccess">
        <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="$emit('cancel')" />
        <ButtonComponent
          :label="$t('cancelContract')"
          :promise="promise"
          @onSuccess="$emit('declined')"
          theme="error"
          type="submit"
          :icon="['fal', 'arrow-to-right']"
        />
      </template>
      <div v-else class="row middle">
        <FontAwesomeIcon :icon="['fal', 'exclamation-triangle']" class="mr-2 text--warning" size="lg" />
        <div>{{ $t('youDoNotHaveSignAuthority') }}</div>
      </div>
    </template>
  </Card>
</template>

<script>
import API from '@/api/Contract'

import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import { AlertComponent as Alert } from 'vue-elder-alert'

export default {
  props: {
    value: Object,
    hasAccess: Boolean,
  },
  data() {
    return {
      reason: null,
      promise: null,
    }
  },
  methods: {
    submit() {
      this.promise = API.decline({ id: this.value.id, message: this.reason })
    },
  },
  components: {
    Card,
    InputComponent,
    Alert,
  },
}
</script>

<style lang="scss">
.contract-decline {
}
</style>
